import { render, staticRenderFns } from "./HowToBuyIOS.vue?vue&type=template&id=6e24ee7a&scoped=true&"
import script from "./HowToBuyIOS.vue?vue&type=script&lang=js&"
export * from "./HowToBuyIOS.vue?vue&type=script&lang=js&"
import style0 from "./HowToBuyIOS.vue?vue&type=style&index=0&id=6e24ee7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24ee7a",
  null
  
)

export default component.exports